export type MutationError = {
  message?: string;
  response?: {
    data?: {
      message?: string;
      errors?: Array<{ message?: string }>;
    };
  };
};

const FALLBACK_MOVE_ERROR = 'Unable to move coverage. Please try again.';

export function getMoveCoverageErrorMessage(error: unknown): string {
  if (!error || typeof error !== 'object') {
    return FALLBACK_MOVE_ERROR;
  }

  const mutationError = error as MutationError;
  const responsePayload = mutationError.response?.data;
  const apiErrorMessage = responsePayload?.errors?.find((item) => Boolean(item?.message))?.message;

  if (apiErrorMessage && apiErrorMessage.trim().length > 0) {
    return apiErrorMessage;
  }

  if (responsePayload?.message && responsePayload.message.trim().length > 0) {
    return responsePayload.message;
  }

  if (mutationError.message && mutationError.message.trim().length > 0) {
    return mutationError.message;
  }

  return FALLBACK_MOVE_ERROR;
}
